import {
  Box,
  Button,
  Heading,
  Stack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  ModalHeader,
  useDisclosure,
  Divider,
  Text,
  TableContainer,
} from '@chakra-ui/react';
import React, {useState, useEffect, useRef} from 'react';
import FlexCard from '../../components/General/FlexCard';
import {useForm} from 'react-hook-form';
import {CustomButton, DatePicker, SubmitButton} from '../../components/General/FormInputs';
import {FileDropper} from '../../components/Reports/FileDropper';
import {queryStringBuilder, postUpload, get, getFile, postDelete} from '../../service/ApiService';
import {BatchO, File} from '../../service/Urls';
import ErrorHelper from '../../service/ErrorHelper';
import '../../styles/reports.css';
import {setGrid} from '../../helpers/SetGrid';
import {useNavigate} from 'react-router-dom';
import ServiceTypeList from '../../components/General/ServiceTypeList';

export const ImportRevenueTracker = () => {
  const getToday = () => {
    const today = new Date();
    let month = today.getMonth() + 1;
    if (today.getMonth() + 1 < 10) {
      month = '0' + (today.getMonth() + 1);
    }
    let day = today.getDate();
    if (today.getDate() < 10) {
      day = '0' + today.getDate();
    }
    const date = today.getFullYear() + '-' + month + '-' + day;
    return date;
  };
  const [files, setFiles] = useState([]);
  const [isDisabled, setIsDisabled] = useState(true);
  const [toast, setToast] = useState(undefined);
  const [startDate, setStartDate] = useState(getToday());
  const [endDate, setEndDate] = useState(getToday());
  const [batchRecords, setBatchRecords] = useState([]);
  const [batchErrors, setBatchErrors] = useState([]);
  const [errorElements, setErrorElements] = useState('');
  const [elements, setElements] = useState([]);

  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteId, setDeleteId] = useState('');

  const navigate = useNavigate();
  const [pages, setPages] = useState({
    pageNum: 1,
    totalPages: 1,
    itemsPerPage: 500,
    getNewPage: curPage => {
      loadData(curPage);
    },
  });
  const {
    register,
    handleSubmit,
    control,
    formState: {errors},
  } = useForm();

  const [pdfUrl, setPdfUrl] = useState('');
  const linkRef = useRef(null);

  useEffect(() => {
    if (pdfUrl.length > 0) linkRef.current.click();
  }, [pdfUrl]);

  useEffect(() => {
    handleSubmit(getBatchoList)();
  }, []);

  useEffect(() => {
    batchRecords.map(record => {
      record.status = getStatus(record.status);
    });
    populateTable();
  }, [batchRecords]);

  const getStatus = status => {
    let name;
    switch (status) {
      case 0:
        name = 'Queued';
        break;
      case 1:
        name = 'Processing';
        break;
      case 2:
        name = 'Complete';
        break;
      case 3:
        name = 'Complete With Errors';
        break;
      case 4:
        name = 'Errored';
        break;
    }
    return name;
  };

  const printReport = async (batchId, fileName) => {
    const url = queryStringBuilder(`${File.BATCHORESULTS}${batchId}/download`);
    // const url = queryStringBuilder(SurveyPrints.reportbuttonFile, params);
    const response = await getFile(url, 'excel');
    if (response.error) {
      setToast({response: {error: 1}, errorMessage: 'Error getting report: ' + response.error});
      return;
    }

    const fileURL = window.URL.createObjectURL(response);

    linkRef.current.setAttribute('download', fileName);

    if (!response.error) {
      setPdfUrl(fileURL);
    }
  };

  const visibleData = useRef({
    fileName: {type: 'link', params: ['batchId', 'fileName'], onClick: printReport},
    dateAdded: 'date',
    startDate: 'date',
    endDate: 'date',
    status: 'text',
    recordCount: 'text',
    exceptionCount: 'text',
    batchNumber: 'text',
    total: 'text',
    calculatedTotal: 'text',
    isDeleted: 'boolean',
  });

  const inputRef = useRef('');
  const handleChange = newFiles => {
    setFiles([]);
    const nFiles = [];
    if (newFiles.length == 1 && (newFiles[0].name.toLowerCase().endsWith('.xls') || newFiles[0].name.toLowerCase().endsWith('.xlsx'))) {
      nFiles.push(newFiles[0]);
      setIsDisabled(false);
    } else {
      for (let x = 0; x < newFiles.length; x++) {
        if (newFiles[x].name.toLowerCase().endsWith('.xls') || newFiles[x].name.toLowerCase().endsWith('.xlsx')) {
          nFiles.push(newFiles[x]);
        } else {
          setToast({response: {error: true}, errorMessage: 'The file "' + newFiles[x].name + '" is not an excel file'});
        }
      }
      setIsDisabled(!nFiles.length > 0);
    }
    setFiles(nFiles);
  };
  const importClient = async data => {
    files.forEach(async file => {
      const formData = new FormData();
      formData.append('files', file);

      // data.type = 1;
      // + data.type
      const response = await postUpload(File.BATCHOUPLOAD + data.ServiceType, formData);
      setToast({response: response, successMessage: 'Successfully uploaded ' + file.name});
    });
    setFiles([]);
  };
  const setDates = () => {
    const formEl = document.forms.batchList;
    const formData = new FormData(formEl);
    setStartDate(formData.startDate);
    setEndDate(formData.endDate);
  };
  const getBatchoList = async data => {
    // + data.type
    const response = await get(File.BATCHORESULTS + (data.ServiceType ?? 1) + '?StartDate=' + data.startDate + '&EndDate=' + data.endDate);
    if (response.data.length > 1 || response.data) {
      response.data.recordCount = response.recordCount;
      setBatchRecords(response.data);
    } else {
      setBatchRecords([response]);
    }
  };

  const onDelete = async () => {
    setIsDeleting(true);

    await postDelete(BatchO.DELETEBATCH + deleteId);
    handleSubmit(getBatchoList)();

    onDeleteClose();

    setIsDeleting(false);
  };

  const {isOpen, onOpen, onClose} = useDisclosure();
  const {isOpen: isDeleteOpen, onOpen: onDeleteOpen, onClose: onDeleteClose} = useDisclosure();
  const populateTable = () => {
    const ExtraColumns = props => {
      if (props.isDeleted) return <Td></Td>;

      if (props.fileError) {
        return (
          <Td>
            <Button
              colorScheme="red"
              variant="outline"
              onClick={() => {
                setErrorElements(props.fileError);
                onOpen();
              }}
            >
              View Error
            </Button>
          </Td>
        );
      }

      return (
        <Td>
          <Button
            colorScheme="red"
            onClick={() => {
              onDeleteOpen();
              setDeleteId(props.batch);
            }}
          >
            Delete
          </Button>
        </Td>
      );
    };

    setGrid(visibleData, batchRecords, pages, setElements, ExtraColumns);
  };

  return (
    <Box>
      <a href={pdfUrl} ref={linkRef} style={{display: 'none'}} />
      <Heading m="2">Import Opportunity Plan Spreadsheets</Heading>
      <FlexCard w="90%" m="auto" minW="200px" p="20">
        <Stack mr="auto" w="100%" justify="start">
          <Box>
            <Heading size="md" mb="3" textAlign="start">
              Survey type
            </Heading>
            <ServiceTypeList control={control} filters={['Funeral', 'Cremation', 'PreNeed']} />
          </Box>
          <form onSubmit={handleSubmit(importClient)}>
            <FileDropper inputRef={inputRef} multiple={true} state={files} setState={setFiles} handleChange={handleChange} />
            <Box>
              <SubmitButton id="formButton" disabled={isDisabled} name="Import Opportunity plan" />
            </Box>
          </form>
          <form id="batchList" onChange={setDates} onSubmit={handleSubmit(getBatchoList)}>
            <Flex my="2">
              <DatePicker defaultValue={startDate} register={register} id="startDate" name="Start Date" errors={errors} required />
              <DatePicker defaultValue={endDate} register={register} id="endDate" name="End Date" errors={errors} required />
              <SubmitButton style={{marginTop: '19px'}} name="Refresh" />
            </Flex>
          </form>
          <TableContainer width={{base: '100%'}}>
            <Table variant="striped" border="solid 2px #0c5f78" colorScheme="mint" size="sm">
              <Thead>
                <Tr border="solid 2px #0c5f78">{elements.header}</Tr>
              </Thead>
              <Tbody>{elements.body}</Tbody>
            </Table>
          </TableContainer>
          <Divider />
        </Stack>
      </FlexCard>
      <Modal blockScrollOnMount={false} size={'6xl'} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader id="header">Errors</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Divider mt="5" colorScheme={'mint'} width={{base: '100%'}} />
            <TableContainer width={{base: '100%'}}>
              <Table variant="striped" border="solid 2px #0c5f78" colorScheme="mint" size={'md'}>
                <Thead>
                  <Tr border="solid 2px #0c5f78">
                    <Th>Error</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {errorElements?.split('\r\n').map((error, index) => {
                    return (
                      <Tr key={index}>
                        <Td>{error}</Td>
                      </Tr>
                    );
                  })}
                </Tbody>
              </Table>
            </TableContainer>
          </ModalBody>

          <ModalFooter>
            <CustomButton name="Close" mr={3} onClick={onClose} />
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal blockScrollOnMount={false} size={'lg'} isOpen={isDeleteOpen} onClose={onDeleteClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Delete Batch</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>Are you sure you want to delete this batch?</Text>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onDeleteClose}>
              Close
            </Button>
            <Button colorScheme="red" onClick={onDelete} disabled={isDeleting}>
              Delete
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <ErrorHelper toastResponse={toast} />
    </Box>
  );
};
